import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { AnalyticContext, IAnalyticContext } from 'src/core/analytics/context/AnalyticContext'
import MeasureController from 'src/core/analytics/MeasureController'

interface ISettings {
  dataLoaded?: boolean
}

export const useMeasureController = (
  metricInfo: MeasureController | string,
  settings: ISettings = {}
) => {
  const { register, sendAnalytics } = useContext<IAnalyticContext>(AnalyticContext)
  const user = useSelector(selectUser)
  const [isMounted, setIsMounted] = useState<boolean>(false)

  const isFinishFirstRenderRef = useRef<boolean>(false)

  const metrics = useMemo(() => {
    if (typeof metricInfo === 'string') {
      return new MeasureController(metricInfo, { user })
    }
    return metricInfo
  }, [metricInfo, user])

  const stopLoadData = useCallback(
    (key?: string) => {
      metrics.stop('renderData', key)
      sendAnalytics(metrics.getWidgetId())
    },
    [metrics, sendAnalytics]
  )

  const startLoadData = useCallback(
    (key?: string) => {
      metrics.start('renderData', key)
      register(metrics.getWidgetId())
    },
    [metrics, register]
  )

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    return () => {
      metrics.stop('initialization')
    }
  }, [metrics])

  if (isMounted) {
    if (settings.dataLoaded) {
      if (!isFinishFirstRenderRef.current) {
        metrics.start('renderData')
      }
    } else {
      metrics.start('render')
    }
  }
  useEffect(() => {
    if (isMounted) {
      metrics.stop('initialization')
      if (settings.dataLoaded) {
        if (!isFinishFirstRenderRef.current) {
          metrics.stop('renderData')
        }
      } else {
        metrics.stop('render')
      }
      isFinishFirstRenderRef.current = true
    }
  })

  return { stopLoadData, startLoadData, metrics }
}
